// Copyright (c) Docugami, Inc. All rights reserved.
import { SET_ASSISTED_AUTH_SETTINGS, SET_SETTINGS_PANEL_SHOWING, SET_WORD_TEST_TASKPANE_SHOWING } from "./types";
import { SettingsState } from "./types";

const initialState: SettingsState = {
    settingsPanelShowing: false,
    assistedAuthoring: {
        currentModel: "MiddleOut",
        showWordTestTaskpane: false,
        contextMode: false
    }
};

export function settingsReducer(
    state = initialState,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any
): SettingsState
{
    switch (action.type)
    {
        case SET_ASSISTED_AUTH_SETTINGS:
        {
            return {
                ...state,
                assistedAuthoring: action.payload
            };
        }

        case SET_WORD_TEST_TASKPANE_SHOWING:
        {
            return {
                ...state,
                assistedAuthoring: {
                    ...state.assistedAuthoring,
                    showWordTestTaskpane: action.payload
                }
            };
        }

        case SET_SETTINGS_PANEL_SHOWING:
        {
            return {
                ...state,
                settingsPanelShowing: action.payload
            }
        }

        default:
            return state;
    }
}
